import {create} from 'zustand'
// test
const useRegistrationFormStore = create((set, get) => ({
	step: 0,
	
	registrationCountry: "-1",
	
	dynamicFormValue: {},
	
	credentials: {
		name: '',
		email: '',
		password: '',
		confirm_password: '',
		referral_code: '',
	},


	setCredentials: (key, value) => set((state) => {
		let newCredentials = {...state.credentials, [key]: value};
		return {credentials: newCredentials};
	}),
	
	setDynamicFormValue: (key, value) => set((state) => {
		let newDynamicFormValue = {...state.dynamicFormValue, [key]: value};
		Object.keys(newDynamicFormValue).forEach((key) => {
			if (newDynamicFormValue[key] === null) {
				delete newDynamicFormValue[key];
			}
		});
		return {dynamicFormValue: newDynamicFormValue};
	}),
	
	setDynamicFormValues: (values, replace = false) => set((state) => {
		if (replace) {
			return {dynamicFormValue: values || {}};
		}
		return {dynamicFormValue: {...state.dynamicFormValue, ...values}};
	}),
	
	replaceDynamicFormValues: (values) => set({
		dynamicFormValue: values || {}
	}),
	
	resetRegistrationForm: () => set({
		step: 0,
		registrationCountry: "-1",
		dynamicFormValue: {},
		credentials: {
			name: '',
			email: '',
			password: '',
			confirm_password: '',
			referral_code: '',
		},
	}),
	
	setStep: (value) => set({step: value}),
	setName: (value) => set({name: value}),
	setEmail: (value) => set({email: value}),
	setPhone: (value) => set({phone: value}),
	
	getCountry: () => get().dynamicFormValue['country'] || '',
}))

export default useRegistrationFormStore;